export class LoginFlyout {
    constructor() {
        const navWrapper = document.getElementById('msQMyAccountNavWrapper');

        navWrapper.addEventListener('mouseenter', () => {
            navWrapper.classList.add('menuHover');
        });
        navWrapper.addEventListener('focus', () => {
            navWrapper.classList.add('menuHover');
        });

        navWrapper.querySelector('.msQMyAccountNavCloseIcon').addEventListener('click', (e) => {
            navWrapper.classList.remove('menuHover');
            navWrapper.blur();
        });
    }
}